module.exports = __webpack_public_path__ + "static/media/IMG_5337.937434cf.JPG";